import React from 'react';
import { injectV2 } from '../../../../injectV2';
import { SeoLink } from '../../../SeoLink/SeoLink';
import { RouteLocation } from '../../../../stores/routes/createRoute';
import { LinkArrow } from '../../../../../Icons/dist';
import { useScrollToTop } from '../../../../contexts/ScrollToTopContext';
import { UiLoggerStore } from '../../../../stores/UiLoggerStore';
import { BaseURLStore } from '../../../../stores/BaseURLStore';
import { WithTranslations, withTranslations } from '../../../../../utils/withTranslations';
import { forYouSectionHeadingDataHooks } from './ForYouSectionHeading.dataHooks';
import s from './ForYouSectionHeading.scss';

interface ForYouSectionHeadingCmpProps extends WithTranslations {
  title: string;
  expandLink?: RouteLocation;
  categorySlug?: string;
  dataHook?: string;
  uiLoggerStore: UiLoggerStore;
  baseURLStore: BaseURLStore;
}
const ForYouSectionHeadingCmp: React.FC<ForYouSectionHeadingCmpProps> = ({
  dataHook,
  title,
  uiLoggerStore,
  baseURLStore,
  expandLink,
  categorySlug,
  t,
}) => {
  const { scrollToTop } = useScrollToTop();
  const handleLinkClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    scrollToTop();
    uiLoggerStore.logClickElement({
      clicked_element: 'explore category',
      clicked_element_identifier: categorySlug,
      openingBrowserUrl: baseURLStore.buildURL(expandLink),
      category: null,
      subCategory: null,
    });
  };

  return (
    <div className={s.root} data-hook={dataHook}>
      <h3 className={s.heading} data-hook={forYouSectionHeadingDataHooks.heading()}>
        {title}
      </h3>
      {expandLink && (
        <SeoLink
          to={expandLink}
          className={s.link}
          onClick={(event) => handleLinkClick(event)}
          dataHook={forYouSectionHeadingDataHooks.link()}
        >
          {t('forYouPage.expand.link')}
          <LinkArrow className={s.arrowIcon} />
        </SeoLink>
      )}
    </div>
  );
};

export const ForYouSectionHeading = withTranslations(
  injectV2('uiLoggerStore', 'baseURLStore')(ForYouSectionHeadingCmp),
);
